<template>
  <div class="tabla-modulos">
    <table id="TablaModulos" class="table table-bordered table-striped tablaModulos">
      <thead>
        <tr>
          <!-- Cantidad -->
          <th width="100">Unidades</th>
          <!-- Nombre del módulo -->
          <th>Módulo</th>
          <!-- Suscripción -->
          <th width="120" v-show="mostrarSuscripcion">Suscripción</th>
          <!-- Cuota Anual -->
          <th width="120">Cuota Anual</th>
          <!-- Horas Consultoría -->
          <th width="80" v-show="mostrarHoras">Horas Consultoría</th>
          <!-- Horas Capacitación -->
          <th width="80" v-show="mostrarHoras">Horas Capacitación</th>
          <!-- Acciones -->
          <th width="120" class="acciones" v-if="borrador">Acciones</th>
        </tr>
      </thead>
      <draggable v-model="modulosParaDraggable" tag="tbody" style="user-select: none">
        <tr v-for="(modulo, index) in soloModulos" :key="index" :class="{ quitado: modulo.eliminado }">
          <!-- Cantidad -->
          <td class="text-center">
            <b-form-spinbutton v-if="borrador" v-model="modulo.cantidad" size="sm" min="1" max="99999" />
            <span v-else>{{ modulo.cantidad }}</span>
          </td>
          <!-- Nombre del módulo -->
          <td>{{ modulo.nombre }}</td>
          <!-- Suscripción -->
          <td v-show="mostrarSuscripcion">
            <b-form-input
              v-if="puedeEditarPrecioSuscripcion(modulo)"
              v-model="modulo.precioSuscripcion"
              type="number"
              min="0"
              @input="actualizarPrecioModulo(modulo)"
            />
            <span v-else>{{ modulo.precioSuscripcion }}</span>
          </td>
          <!-- Cuota Anual -->
          <td>
            <b-form-input
              v-if="puedeEditarPrecioCuotaAnual(modulo)"
              v-model="modulo.precioCuotaAnual"
              type="number"
              min="0"
              @input="actualizarPrecioModulo(modulo)"
            />
            <span v-else>{{ modulo.precioCuotaAnual }}</span>
          </td>
          <!-- Horas Consultoría -->
          <td class="text-center" v-show="mostrarHoras">
            <b-form-input v-if="puedeEditarHoras(modulo)" v-model="modulo.numHorasConsultoria" type="number" min="0" />
            <span v-else>{{ modulo.numHorasConsultoria }}</span>
          </td>
          <!-- Horas Capacitación -->
          <td class="text-center" v-show="mostrarHoras">
            <b-form-input v-if="puedeEditarHoras(modulo)" v-model="modulo.numHorasCapacitacion" type="number" min="0" />
            <span v-else>{{ modulo.numHorasCapacitacion }}</span>
          </td>
          <td v-if="borrador" class="acciones">
            <b-button
              v-if="!modulo.eliminado"
              v-b-tooltip.hover
              size="sm"
              variant="danger"
              class="bbutton-mini"
              @click="eliminarModulo(modulo)"
            >
              <v-icon variant="danger" name="trash-2" width="16" />
              Quitar
            </b-button>
            <b-button
              v-if="modulo.eliminado"
              v-b-tooltip.hover
              size="sm"
              variant="secondary"
              class="bbutton-mini"
              @click="restaurarModulo(modulo)"
            >
              <v-icon variant="secondary" name="corner-up-left" width="16" />
              Restaurar
            </b-button>
          </td>
        </tr>
      </draggable>
      <sin-registros :count="soloModulos.length" :colspan="7" />
    </table>
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import draggable from "vuedraggable";
import { SAAS, INVERSION } from "@/enums/TipoProyecto";

export default {
  components: {
    draggable,
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    ...mapState(useOfertaFormStore, ["borrador", "oferta", "soloModulos"]),
    mostrarSuscripcion() {
      return this.oferta.tipoProyecto == INVERSION;
    },
    mostrarHoras() {
      return this.oferta.tipoProyecto == INVERSION || this.oferta.tipoProyecto == SAAS;
    },
    modulosParaDraggable: {
      get() {
        return this.soloModulos;
      },
      set(value) {
        // Reordenamos los módulos
        value.forEach((modulo, index) => (modulo.ordenModulo = index));

        // Actualizamos el store
        useOfertaFormStore().setOfertaModulos(value);
      },
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    eliminarModulo(modulo) {
      modulo.eliminado = true;
    },
    restaurarModulo(modulo) {
      modulo.eliminado = false;
    },
    puedeEditarPrecioSuscripcion(modulo) {
      return this.borrador && modulo.permiteCambioPrecio > 0;
    },
    puedeEditarPrecioCuotaAnual(modulo) {
      return this.borrador && (modulo.permiteCambioPrecio > 0 || Boolean(this.esAdmin));
    },
    puedeEditarHoras(modulo) {
      return this.borrador && modulo.permiteCambioHoras > 0;
    },
    actualizarPrecioModulo(modulo) {
      modulo.precioModificado = true;
    },
  },
};
</script>
